import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Suppress the benign "ResizeObserver loop completed with undelivered
// notifications" warning. It is a harmless browser no-op emitted by layout
// measuring UI libs (Radix, @floating-ui, charts, etc.). CRA's dev overlay
// otherwise surfaces it as a fatal runtime error.
//
// Root-cause fix: wrap the ResizeObserver callback in requestAnimationFrame so
// the work runs outside the synchronous resize cycle, which prevents the loop
// notification from ever being emitted. (One-frame defer is imperceptible and
// does not affect Radix/floating-ui positioning correctness.)
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Secondary safety net: silence the error if it still reaches the window.
const isResizeObserverLoopError = (msg) =>
  typeof msg === "string" &&
  (msg.includes("ResizeObserver loop completed with undelivered notifications") ||
    msg.includes("ResizeObserver loop limit exceeded"));

window.addEventListener(
  "error",
  (e) => {
    if (isResizeObserverLoopError(e?.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
